export class MeshLocationUtils
{
    public static getLetterByColumnIndex(columnIndex:number):string
    {
        if( columnIndex == null )
            return null;

        return MeshLocationUtils.getLetterByColumn(columnIndex + 1);
    }

    public static getLetterByColumn(column:number):string
    {
        if( column == null )
            return null;

        let temp:number;
        let letter:string = '';

        while( column > 0 )
        {
            temp = (column - 1) % 26;
            letter = String.fromCharCode(temp + 65) + letter;
            column = (column - temp - 1) / 26;
        }

        return letter;
    }

    public static getColumnIndexByLetter(letter:string):number
    {
        if( letter == null || letter.length === 0 )
            return null;

        return MeshLocationUtils.getColumnByLetter(letter) - 1;
    }

    public static getColumnByLetter(letter:string):number
    {
        if( letter == null || letter.length === 0 )
            return null;

        let column:number = 0;

        for( let i = 0; i < letter.length; i++ )
        {
            column = column * 26 + (letter.toUpperCase().charCodeAt(i) - 64);
        }

        return column;
    }

    public static getRowIndexByLetter(letter:string):number
    {
        if( letter == null || letter.length === 0 )
            return null;

        return MeshLocationUtils.getRowByLetter(letter) - 1;
    }

    public static getRowByLetter(letter:string):number
    {
        if( letter == null || letter.length === 0 )
            return null;

        return parseFloat(letter);
    }
}
